module.exports = __webpack_public_path__ + "img/Settings-adjust.072c97f3.svg";